// src/pages/Help/components/QuickStartSection.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Button } from "reactstrap";

const QuickStartSection = ({ data }) => {
  const navigate = useNavigate();

  const handleQuickStartClick = () => {
    navigate("/help/quickstart");
  };

  return (
    <Card
      style={{
        border: "1px solid #e5e7eb",
        height: "fit-content",
        borderRadius: "4px", // Sharp corners like FAQ
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
      onClick={handleQuickStartClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)";
      }}
    >
      <CardBody style={{ padding: "16px" }}>
        {" "}
        <div className="text-center mb-3">
          <div
            className="mx-auto rounded d-flex align-items-center justify-content-center"
            style={{
              width: "100%",
              height: "150px",
              backgroundImage: data.headerImage
                ? `url(${data.headerImage})`
                : "none",
              backgroundColor: data.headerImage
                ? "transparent"
                : "linear-gradient(135deg, #2F9E37 0%, #27803d 100%)", // Updated gradient colors
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              border: "1px solid #e5e7eb",
              borderRadius: "4px", // Sharp corners
            }}
          >
            {!data.headerImage && (
              <div className="text-center">
                <i
                  className="ri-play-circle-line"
                  style={{
                    fontSize: "40px", // Slightly smaller
                    color: "#ffffff",
                    marginBottom: "6px",
                  }}
                ></i>
                <div
                  style={{
                    color: "#ffffff",
                    fontSize: "12px", // Smaller font
                    fontWeight: "600",
                    textShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  QUICK START GUIDE
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Title */}
        <h5
          className="mb-2 fw-bold"
          style={{
            color: "#2F9E37", // Updated color to match FAQ
            fontSize: "16px", // Smaller to match FAQ
            lineHeight: "1.3",
          }}
        >
          {data.title}
        </h5>
        {/* Description */}
        <p
          className="text-muted mb-3"
          style={{
            fontSize: "12px", // Smaller font
            lineHeight: "1.4",
            color: "#6b7280",
          }}
        >
          {data.description}
        </p>
        {/* Content Preview */}
        <div className="mb-3">
          <div className="d-flex align-items-center mb-1">
            <div
              style={{
                width: "3px", // Smaller dots
                height: "3px",
                backgroundColor: "#2F9E37", // Updated color
                borderRadius: "50%",
                marginRight: "6px",
              }}
            />
            <span style={{ color: "#6b7280", fontSize: "11px" }}>
              Visualising An Individual Gene/Transcript
            </span>
          </div>
          <div className="d-flex align-items-center mb-1">
            <div
              style={{
                width: "3px",
                height: "3px",
                backgroundColor: "#2F9E37", // Updated color
                borderRadius: "50%",
                marginRight: "6px",
              }}
            />
            <span style={{ color: "#6b7280", fontSize: "11px" }}>
              Step-by-step walkthrough
            </span>
          </div>
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "3px",
                height: "3px",
                backgroundColor: "#2F9E37", // Updated color
                borderRadius: "50%",
                marginRight: "6px",
              }}
            />
            <span style={{ color: "#6b7280", fontSize: "11px" }}>
              Example dataset included
            </span>
          </div>
        </div>
        {/* View Button */}
        <div className="text-end">
          {/* Centered like FAQ button */}
          <Button
            style={{
              backgroundColor: "#2F9E37", // Updated color
              borderColor: "#2F9E37",
              color: "#ffffff",
              fontWeight: "600",
              padding: "6px 16px", // Reduced padding
              borderRadius: "4px", // Sharp corners
              fontSize: "11px", // Smaller font
              border: "none",
              transition: "all 0.2s ease",
              width: "auto", // Auto width instead of 100%
              minWidth: "120px", // Minimum width for readability
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#27803d"; // Darker hover color
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#2F9E37";
            }}
          >
            <i className="ri-play-circle-line me-1"></i>
            Start Guide
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default QuickStartSection;
